const deleteRow = ({ key, items }) =>
  items.filter(item => item.id !== key)

export default deleteRow;
